import React from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import type { Recipient } from '../types';
import { formatWhatsappDisplay } from '../utils';
import { RecipientSentBadge } from './RecipientSentBadge';
import { RecipientStatusBadge } from './RecipientStatusBadge';

const TABLE_CHECKBOX_CLASS =
  'h-[18px] w-[18px] rounded-[4px] border-gray-300 shadow-none data-[state=checked]:bg-black data-[state=checked]:border-black data-[state=checked]:text-white data-[state=indeterminate]:bg-black data-[state=indeterminate]:border-black data-[state=indeterminate]:text-white';

interface RecipientsTableRowProps {
  recipient: Recipient;
  selected: boolean;
  onToggle: (_id: string) => void;
}

export const RecipientsTableRow: React.FC<RecipientsTableRowProps> = ({
  recipient,
  selected,
  onToggle,
}) => (
  <tr className="border-b border-[#E5E5E5] last:border-b-0">
    <td className="px-5 py-4 pl-5 pr-2 align-middle">
      <Checkbox
        checked={selected}
        disabled={recipient.alreadySent}
        onCheckedChange={() => onToggle(recipient.id)}
        aria-label={`Selecionar ${recipient.name}`}
        className={TABLE_CHECKBOX_CLASS}
      />
    </td>
    <td className="px-3 py-4 align-middle">
      <div className="font-sans text-sm font-medium leading-5 text-[#0A0A0A]">
        {recipient.name}
      </div>
      <div className="mt-0.5 font-sans text-sm font-normal leading-5 tracking-normal text-[#737373]">
        {recipient.email}
      </div>
    </td>
    <td className="whitespace-nowrap px-3 py-4 align-middle font-sans text-sm font-normal leading-5 text-[#0A0A0A]">
      {formatWhatsappDisplay(recipient.whatsapp)}
    </td>
    <td className="whitespace-nowrap px-3 py-4 align-middle">
      <RecipientStatusBadge status={recipient.status} />
    </td>
    <td className="whitespace-nowrap px-3 py-4 pr-5 align-middle">
      <RecipientSentBadge alreadySent={Boolean(recipient.alreadySent)} />
    </td>
  </tr>
);

export { TABLE_CHECKBOX_CLASS };
